import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
function LibasMenuWomens({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");
  const ClothesWomen = [
    {
      name: "Coats",
    },

    {
      name: "Dresses",
    },
    {
      name: "Jackets",
    },
    {
      name: "Jeans",
    },
    {
      name: "Jumpsuits",
    },

    {
      name: "Knitwear",
    },
    {
      name: "Leather jackets",
    },

    {
      name: "Shorts",
    },
    {
      name: "Skirts",
    },
    // {
    //     name:'Sets'
    // },
    {
      name: "Swimwear",
    },

    {
      name: "Tops",
    },
    {
      name: "Trench coats",
    },
    {
      name: "Trousers",
    },
    {
      name: "Lingerie",
    },
  ];

  const ShoesWomen = [
    {
      name: "Sandals",
    },

    {
      name: "Trainers",
    },
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },

    {
      name: "Mules & Clogs",
    },
    {
      name: "Heels",
    },

    {
      name: "Ballet flats",
    },
    {
      name: "Lace ups",
    },

    {
      name: "Ankle boots",
    },
  ];

  const bagswomen = [
    { name: "Handbags", nameAr: "حقائب يد" },
    { name: "Crossbody bags", nameAr: "حقائب كروس" },
    { name: "Shoulder bags", nameAr: "حقائب كتف" },
    { name: "Tote bags", nameAr: "حقائب توت" },
    { name: "Clutch bags", nameAr: "حقائب صغيرة" },
    { name: "Travel bags", nameAr: "حقائب سفر" },
    { name: "Backpacks", nameAr: "حقائب ظهر" },
  ];
  const AccWomen = [
    {
      name: "Gloves",
    },
    {
      name: "Hats",
    },
    {
      name: "Purses & cases",
    },
    {
      name: "Scarves",
    },
    {
      name: "Silk handkerchief",
    },
    {
      name: "Sunglasses",
    },

    {
      name: "Belts",
    },
    {
      name: "Bag accessories",
    },
    {
      name: "Wallets",
    },
    // {
    //   name: "Watches",
    // },
  ];
  const JewelleryWomen = [
    {
      name: "Bracelets",
    },

    {
      name: "Earrings",
    },
    {
      name: "Necklaces",
    },
    {
      name: "Rings",
    },
    {
      name: "Pins & brooches",
    },

    {
      name: "Pendants",
    },
    {
      name: "Bag charms",
    },

    {
      name: "Hair accessories",
      id: "WhvbBFPU8ovRs2PD3Afj",
    },
    {
      name: "Jewellery sets",
    },
  ];
  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* Womens */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("womens")}
          style={{
            borderBottom:
              expandedCategory === "womens" ? "none" : "1px solid #dee2e6",
            borderBottomColor: expandedCategory === "womens" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "womens" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?gender=WFA967se7qX0jYtySgTj"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "womens") {
                setHide(true);
                return;
              } else {
                setActiveFilter("womens");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "womens" ? "500" : "400",
                textDecoration:
                  expandedCategory === "womens" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Women")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "womens" ? menuup : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "womens" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of womens */}
                  <ul className="list-unstyled">
                    {/* clothes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj`}
                          className="subtitlemega "
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{
                              marginLeft: "15px",
                            }}
                            onClick={() =>
                              navigateToCategory("womens", "clothes")
                            }
                          >
                            {t("Clothes")}
                          </motion.button>
                        </Link>
                        {/* Animated arrow for subcategory */}
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("clothes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.clothes ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.clothes
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for women clothes */}
                      <AnimatePresence>
                        {expandedSubcategories.clothes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {ClothesWomen?.map((cloth) =>
                              SubCategory?.filter(
                                (subcat) => subcat?.name === cloth?.name
                              )
                                ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                ?.map((sub) => (
                                  <Link
                                    key={sub?.id}
                                    to={`/products?topic=newdrops&subcategory=${sub.id}&id=yJDeEt0uKPxfxtqOM42V`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "womens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("womens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "womens",
                                            "clothes",
                                            sub.slug || sub.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub.name
                                          : sub.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* shoes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("womens", "womens")
                            }
                          >
                            {t("Shoes")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("shoes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.shoes ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.shoes ? menudown : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for shoes-women */}
                      <AnimatePresence>
                        {expandedSubcategories?.shoes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {SubCategory?.filter(
                              (subcat) =>
                                subcat?.idTypeCategory ===
                                  "WJmwaMSWxtl1dK1sPZ1x" &&
                                ShoesWomen?.some(
                                  (shoe) => shoe?.name === subcat?.name
                                )
                            )
                              ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                              ?.map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "womens",
                                          "bags",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* Bags with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("womens", "mens")}
                          >
                            {t("Bags")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("womenbags");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.womenbags ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.womenbags
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for bags */}
                      <AnimatePresence>
                        {expandedSubcategories?.womenbags && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {SubCategory.filter(
                              (subcat) =>
                                subcat.idTypeCategory ===
                                  "AqFLulu9y2m4mqEIkch1" &&
                                bagswomen.some(
                                  (bag) => bag.name === subcat.name
                                )
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "womens",
                                          "bags",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* accessories with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("womens", "mens")}
                          >
                            {t("Accessories")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("accessories");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.accessories ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.accessories
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for accessories */}
                      <AnimatePresence>
                        {expandedSubcategories?.accessories && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {AccWomen?.map((acc) =>
                              SubCategory?.filter(
                                (subcat) =>
                                  subcat?.name === acc?.name &&
                                  subcat?.idTypeCategory ===
                                    "LVw0hUP9kEcd1Qr9CoEk"
                              )?.map((sub) => (
                                <Link
                                  key={sub?.id}
                                  to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&subcategory=${sub?.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "womens",
                                          "accessories",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* watches and jew with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("womens", "mens")}
                          >
                            {t("watchesandJewelry")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("watchesandJewelry");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.watchesandJewelry
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.watchesandJewelry
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for watchesandJewelry */}
                      <AnimatePresence>
                        {expandedSubcategories?.watchesandJewelry && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {SubCategory?.filter(
                              (subcat) =>
                                subcat?.idTypeCategory ===
                                  "07kdA6cD3NDKxX8pQ7w1" &&
                                subcat?.id !== "8aLDyffgJkHZdmFkFwRc" &&
                                JewelleryWomen?.some(
                                  (jewel) => jewel?.name === subcat?.name
                                )
                            )
                              ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                              ?.map((sub) => {
                                // Check if this is hair accessories
                                const isHairAccessories =
                                  sub?.name === "Hair accessories";

                                // Use different link URL for hair accessories
                                const linkUrl = isHairAccessories
                                  ? `/products?subcategory=WhvbBFPU8ovRs2PD3Afj`
                                  : `/products?id=${sub?.idTypeCategory}&subcategory=${sub?.id}&gender=WFA967se7qX0jYtySgTj`;

                                return (
                                  <Link
                                    key={sub?.id}
                                    to={linkUrl}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "womens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("womens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "womens",
                                            "jewellery",
                                            sub.slug || sub.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub.name
                                          : sub.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                );
                              })}
                            {SubCategory.filter(
                              (subcat) => subcat.id === "kYTvn5wAxopx5jpqotC0"
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "womens",
                                          "jewellery",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuWomens;
